import { render, staticRenderFns } from "./ViewBalance.vue?vue&type=template&id=02f6b5cc"
import script from "./ViewBalance.vue?vue&type=script&lang=js"
export * from "./ViewBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports